import React from "react";
import { Grid2 } from "@mui/material";

import { servicesCardsMock } from "./model/constants";
import { ServicesCard } from "./ServicesCard/ServicesCard";

export const ServicesCards: React.FC = () => {
  return (
    <Grid2
      container
      columns={{ xs: 4 }}
      spacing={4}
      direction="row"
      alignItems="stretch"
    >
      {servicesCardsMock.map((projectCard, index) => (
        <ServicesCard
          key={projectCard.title}
          title={projectCard.title}
          descriptions={projectCard.descriptions}
          index={index + 1}
        />
      ))}
    </Grid2>
  );
};
